<script lang="ts">
  import BaseModule from '$src/js/app/base/BaseModule';
  import Svg from '$src/js/components/_base/svg/Svg.svelte';

  const {
    onClose,
    openExplanationModal,
    href,
  }: {
    onClose: () => void;
    openExplanationModal: () => void;
    href: string;
  } = $props();
</script>

<div
  class="force-dark-theme text-text-neutral-def-primary text-13asrem border-stroke-neutral-def-tertiary bg-surface-neutral-def-base flex min-h-[32px] flex-row items-center gap-2 border-b-1 px-4 leading-[130%]"
  data-nosnippet
>
  <a
    {href}
    target="_self"
    class="flex flex-1 flex-row gap-1.5 font-semibold"
    onclick={openExplanationModal}
  >
    <Svg icon="add-to-homescreen-colorized" size="16" />
    <span>{BaseModule.getInstance().i18n.translate('addToHomescreen_button_trigger')}</span>
  </a>
  <button onclick={onClose} class="font-regular"
    >{BaseModule.getInstance().i18n.translate('addToHomescreen_button_hide')}</button
  >
</div>
